// Egen rullgardin for variantvaljaren.
//
// En native <option> gar inte att layouta: priset kan inte hogerstallas och
// Popular kan inte bli en banner. Darfor ritas en egen lista ovanpa. Den riktiga
// <select> ligger kvar, dold, och ar fortfarande den som formularet skickar och
// som variant-picker.js lyssnar pa — vi satter bara dess varde och skickar
// 'change', precis som ett musklick i en vanlig rullgardin hade gjort.
//
// Knappen renderas av Liquid, inte harifran. Da overlever den att sektionen
// ritas om vid varje variantbyte, och dess text kommer alltid fran servern.
// Panelen byggs forst nar nagon oppnar, och slangs nar den stangs — sa finns
// det aldrig nagot inaktuellt kvar att halla i synk.
(function () {
  if (window.bozettoVariantSelect) return;
  window.bozettoVariantSelect = true;

  var OPPEN = null;

  function selectFor(behallare) {
    return behallare.querySelector('select.variant-option__select');
  }

  function stang() {
    if (!OPPEN) return;

    var panel = OPPEN.querySelector('.bz-select__panel');
    if (panel) panel.remove();

    var knapp = OPPEN.querySelector('.bz-select__trigger');
    if (knapp) knapp.setAttribute('aria-expanded', 'false');

    OPPEN = null;
  }

  function radFor(option) {
    var rad = document.createElement('li');
    rad.className = 'bz-select__option';
    rad.setAttribute('role', 'option');
    rad.dataset.varde = option.value;
    rad.setAttribute('aria-selected', option.selected ? 'true' : 'false');

    var namn = document.createElement('span');
    namn.className = 'bz-select__name';
    namn.textContent = option.dataset.label || option.value;
    rad.appendChild(namn);

    // Ordinarie priset ligger fore det aktuella och ar overstruket, sa raden
    // lases som "fran X ner till Y".
    var ordinarie = (option.dataset.compare || '').trim();
    if (ordinarie) {
      var ordinarieEl = document.createElement('s');
      ordinarieEl.className = 'bz-select__compare';
      ordinarieEl.textContent = ordinarie;
      rad.appendChild(ordinarieEl);
    }

    var pris = (option.dataset.price || '').trim();
    if (pris) {
      var prisEl = document.createElement('span');
      prisEl.className = 'bz-select__price';
      prisEl.textContent = pris;
      if (ordinarie) prisEl.classList.add('bz-select__price--nedsatt');
      rad.appendChild(prisEl);
    }

    var popular = (option.dataset.popular || '').trim();
    if (popular) {
      var markeEl = document.createElement('span');
      markeEl.className = 'bz-select__badge';
      markeEl.textContent = popular;
      rad.appendChild(markeEl);
    }

    return rad;
  }

  function oppna(behallare) {
    var valjare = selectFor(behallare);
    if (!valjare) return;

    stang();

    var panel = document.createElement('ul');
    panel.className = 'bz-select__panel';
    panel.setAttribute('role', 'listbox');

    Array.prototype.forEach.call(valjare.options, function (option) {
      // Dolda varden ar kombinationer som inte finns — t.ex. 13x18 i canvas.
      if (option.hidden) return;
      panel.appendChild(radFor(option));
    });

    if (!panel.children.length) return;

    behallare.appendChild(panel);

    var knapp = behallare.querySelector('.bz-select__trigger');
    if (knapp) knapp.setAttribute('aria-expanded', 'true');

    OPPEN = behallare;

    var vald = panel.querySelector('[aria-selected="true"]');
    if (vald && vald.scrollIntoView) vald.scrollIntoView({ block: 'nearest' });
  }

  function valj(behallare, varde) {
    var valjare = selectFor(behallare);
    if (!valjare || valjare.value === varde) {
      stang();
      return;
    }

    valjare.value = varde;
    stang();
    valjare.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function flytta(steg) {
    if (!OPPEN) return;

    var rader = Array.prototype.slice.call(OPPEN.querySelectorAll('.bz-select__option'));
    if (!rader.length) return;

    var nuvarande = rader.findIndex(function (r) {
      return r.hasAttribute('data-aktiv');
    });

    if (nuvarande === -1) {
      nuvarande = rader.findIndex(function (r) {
        return r.getAttribute('aria-selected') === 'true';
      });
    }

    var nasta = Math.min(rader.length - 1, Math.max(0, nuvarande + steg));

    rader.forEach(function (r) {
      r.removeAttribute('data-aktiv');
    });

    rader[nasta].setAttribute('data-aktiv', '');
    if (rader[nasta].scrollIntoView) rader[nasta].scrollIntoView({ block: 'nearest' });
  }

  document.addEventListener('click', function (handelse) {
    if (!(handelse.target instanceof Element)) return;

    var rad = handelse.target.closest('.bz-select__option');
    if (rad && OPPEN) {
      handelse.preventDefault();
      valj(OPPEN, rad.dataset.varde);
      return;
    }

    var knapp = handelse.target.closest('.bz-select__trigger');
    if (knapp) {
      handelse.preventDefault();
      var behallare = knapp.closest('[data-bz-select]');
      if (!behallare) return;
      if (OPPEN === behallare) stang();
      else oppna(behallare);
      return;
    }

    if (OPPEN && !handelse.target.closest('[data-bz-select]')) stang();
  });

  document.addEventListener('keydown', function (handelse) {
    if (!OPPEN) return;

    if (handelse.key === 'Escape') {
      var knapp = OPPEN.querySelector('.bz-select__trigger');
      stang();
      if (knapp) knapp.focus();
      return;
    }

    if (handelse.key === 'ArrowDown') {
      handelse.preventDefault();
      flytta(1);
      return;
    }

    if (handelse.key === 'ArrowUp') {
      handelse.preventDefault();
      flytta(-1);
      return;
    }

    if (handelse.key === 'Enter' || handelse.key === ' ') {
      var aktiv = OPPEN.querySelector('.bz-select__option[data-aktiv]');
      if (!aktiv) return;
      handelse.preventDefault();
      valj(OPPEN, aktiv.dataset.varde);
    }
  });

  // Panelen ligger i samma behallare som knappen och foljer med vid sidscroll,
  // sa den behover inte stangas da. Vid storleksandring kan den daremot hamna
  // fel, och efter ett variantbyte ar sektionen omritad under den.
  window.addEventListener('resize', stang);
  document.addEventListener('variant:update', stang);

  // Knapparna ar dolda tills skriptet kor, sa att den riktiga rullgardinen
  // fungerar som vanligt om det uteblir.
  document.documentElement.classList.add('bz-select-on');
})();
